import { DerogationRequest, ExemptionData } from './exemption.component.model';
import { convertStringToNumber } from '@tribeauto/ngx-mobilite-material';

export const toDerogationRequest = (exemptionData: ExemptionData): DerogationRequest => {
  return {
    changeDate: new Date(),
    description: exemptionData.exemptionReason,
    initialValue: convertStringToNumber(exemptionData.redemptionValue),
    purchaseCommit: exemptionData.repurchaseAgreement,
    requestedValue: convertStringToNumber(exemptionData.desiredRedemptionValue),
    status: '1'
  };
};
